import { render, staticRenderFns } from "./LoginPersonalizeList.vue?vue&type=template&id=48f04e10&scoped=true"
import script from "./LoginPersonalizeList.vue?vue&type=script&lang=js"
export * from "./LoginPersonalizeList.vue?vue&type=script&lang=js"
import style0 from "./LoginPersonalizeList.vue?vue&type=style&index=0&id=48f04e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f04e10",
  null
  
)

export default component.exports